/* eslint-disable no-param-reassign */
<template>
	<div class="container-sidebar" :class="collapsed ? activebar : inactivebar">
		<div class="container-logo">
			<!--  <img
        class="logo"
        src="../../../assets/icons/logo.png"
        :class="{ 'nav-collapsed-img': collapsed === false }"
      > -->
			<span>{{ appName }}</span>
		</div>
		<div v-for="(menu, index) in menuItems" :key="menu.name" class="container_icons">
			<div
				v-if="!menu.hidden"
				class="menu-principal"
				:class="{
					'active-menu': menu.isRotate && !menu.children,
					'active-one': menu.active === true,
					'nav-collapsed-menu': collapsed === false,
				}"
				@click="menuActions(index, menu.name)"
			>
				<div class="menu-title">
					<feather
						:type="menu.icon"
						:class="collapsed ? 'menu-principal-icon' : 'menu-principal-icon-collapsed'"
					/>
					<h1 :class="collapsed ? 'activebar' : 'inactivebar'">
						{{ menu.title }}
					</h1>
				</div>
				<div v-if="menu.children" :class="collapsed ? 'activebar' : 'inactivebar'">
					<feather
						class="icon-menu"
						:class="{ rotate: menu.isRotate }"
						type="chevron-down"
						size="10"
					/>
				</div>
			</div>
			<div
				v-if="menu.children"
				class="container-submenu"
				:class="{ active: menu.isRotate && !menu.children }"
			>
				<div
					v-for="(submenu, sub_index) in menu.children"
					:key="submenu.name"
					class="submenu"
					:class="{
						visible: submenu.active,
						invisible: collapsed === false,
						childactive: submenu.childActive,
					}"
					@click="navigateToRoute(index, sub_index, submenu.name)"
				>
					<h1 class="submenu-title">
						{{ submenu.title }}
					</h1>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			appName: process.env.VUE_APP_NAME,
			activebar: 'activebarWidth',
			inactivebar: 'inactivebarWidth',
			showSubmenu: false,
			colapseSubmenu: true,
			isRotate: false,
			menuItems: [
				{
					title: 'Ecommerce',
					name: 'Ecommerce',
					icon: 'shopping-cart',
					isRotate: false,
					active: false,
					children: [
						{
							title: 'Analytics',
							name: 'Analytics',
							icon: 'home',
							active: false, // Sempre usar essa tab ou não aparece o menu
							childActive: false,
						},
						{
							title: 'Componentes',
							name: 'Componentes',
							icon: 'home',
							active: false,
							childActive: false,
						},
						/*  {
              title: 'Empresas',
              name: 'Empresas',
              icon: 'home',
              active: false, // Sempre usar essa var ou não aparece o menu
            }, */
					],
				},
				{
					title: 'Clientes ',
					name: 'Clientes',
					icon: 'users',
					isRotate: false,
					active: false,
					children: [
						{
							title: 'Usuários',
							name: 'Usuarios',
							icon: 'user',
							active: false,
							childActive: false,
						},
						{
							title: 'Cadastro',
							name: 'PreCadastro',
							icon: 'user-plus',
							active: false,
							childActive: false,
						},
					],
				},
				{
					title: 'Pedidos',
					name: 'Pedidos',
					icon: 'file-text',
					active: false,
				},
				{
					title: 'Grupos de Produtos',
					name: 'GruposProdutos',
					icon: 'file-text',
					active: false,
				},
				{
					title: 'Pagamento Cartão',
					name: 'PagamentoCartao',
					icon: 'credit-card',
					active: false,
				},
				{
					title: 'Relatórios',
					name: 'Relatorios',
					icon: 'clipboard',
					isRotate: false,
					active: false,
					children: [
						{
							title: 'Integrações',
							name: 'Integracoes',
							icon: 'database',
							active: false,
							childActive: false,
						},
					],
				},
				{
					title: 'Parâmetros de Pedido',
					name: 'Parâmetros de Pedido',
					icon: 'sliders',
					isRotate: false,
					active: false,
					children: [
						{
							title: 'Forma de Pagamento',
							name: 'FormaPagamento',
							icon: 'home',
							active: false,
							childActive: false,
						},
						{
							title: 'Condição de Pagamento',
							name: 'CondPagamento',
							icon: 'home',
							active: false,
							childActive: false,
						},
						{
							title: 'Tabela de Vendas',
							name: 'TabVendas',
							icon: 'home',
							active: false,
							childActive: false,
						},
					],
				},
				{
					title: 'Administração',
					name: 'Administração',
					icon: 'settings',
					isRotate: false,
					active: false,
					children: [
						{
							title: 'Usuários',
							name: 'AdmUsers',
							icon: 'home',
							active: false,
							childActive: false,
						},
						/*  {
              title: 'Permissões',
              name: 'SettingPermission',
              icon: 'home',
              active: false,
            },
            {
              title: 'Cargos',
              name: 'SettingRole',
              icon: 'home',
              active: false,
            }, */
						/*   {
              title: 'Menus',
              name: 'SettingMenu',
              icon: 'home',
              active: false,
            }, */
					],
				},
				/*
				{
					title: 'E-commerce',
					name: 'E-commerce',
					icon: 'shopping-cart',
					isRotate: false,
					children: [
				 	{
							title: 'Produtos em Destaque',
							name: 'Produtos em Destaque',
							icon: 'home',
							active: false,
						},
						{
							title: 'Componentes',
							name: 'Componentes',
							icon: 'home',
							active: false,
						},
					],
				}, */
				{
					title: 'Gestão de currículos',
					name: 'Gestão de currículos',
					icon: 'file',
					isRotate: false,
					hidden: process.env.VUE_APP_STORE_SHOW_TABALHE_CONOSCO !== 'true',
				},
			],
		};
	},
	computed: {
		collapsed() {
			return this.$store.getters.getBarStatus;
		},
	},
	methods: {
		menuActions(index, name) {
			this.$store.dispatch('setBarStatus', true);

			if (this.menuItems[index].children) {
				this.menuItems = this.menuItems.map((itemFrt) => {
					const closedMenu = itemFrt;
					closedMenu.active = false;
					return closedMenu;
				});
				this.menuItems[index].isRotate = !this.menuItems[index].isRotate;
				this.menuItems[index].children.map((item, childIndex) => {
					if (item.active === true || item.active === false) {
						const childStatus = !this.menuItems[index].children[childIndex].active;
						this.menuItems[index].children[childIndex].active = childStatus;
						return true;
					}
					return false;
				});
			} else {
				if (this.$router.currentRoute.name === name) return;

				const l = this.$router.resolve({ name });

				if (l.resolved.matched.length > 0) {
					this.menuItems = this.menuItems.map((itemFrt) => {
						const closedMenu = itemFrt;
						closedMenu.active = false;
						return closedMenu;
					});
					this.menuItems[index].active = true;
					this.$router.push({ name });
				} else {
					this.$buefy.notification.open({
						message: `Route ${name} doesn't exist!`,
						type: 'is-warning',
					});
				}
			}

			this.menuItems
				.filter((x) => x.isRotate && x.name !== name)
				.map((menuItem) => {
					if (menuItem.children) {
						menuItem.children.map((menuItemChildren) => {
							// eslint-disable-next-line no-param-reassign
							menuItemChildren.active = false;
							// eslint-disable-next-line no-param-reassign
							menuItemChildren.childActive = false;
							return menuItemChildren;
						});
					}
					// eslint-disable-next-line no-param-reassign
					menuItem.isRotate = false;
					return menuItem;
				});

			this.showSubmenu = !this.showSubmenu;
			this.colapseSubmenu = !this.colapseSubmenu;
		},
		navigateToRoute(parentIndex, childindex, name) {
			if (this.$router.currentRoute.name === name) return;
			const l = this.$router.resolve({ name });

			if (l.resolved.matched.length > 0) {
				this.$router.push({ name });
				if (this.menuItems[parentIndex].children[childindex]) {
					// eslint-disable-next-line
					this.menuItems[parentIndex].children.forEach(
						// eslint-disable-next-line
						(childItem) => (childItem.childActive = false)
					);
					this.menuItems[parentIndex].children[childindex].childActive = true;
				}
			} else {
				this.$buefy.notification.open({
					message: `Route ${name} doesn't exist!`,
					type: 'is-warning',
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.container-logo {
	display: flex;
	margin: 25px 0;
	align-items: center;
	justify-content: center;
}
.container-logo span {
	font-size: 22px;
	font-weight: bold;
}
.logo {
	width: 120px;
	transition: all ease-in-out 0.5s;
}
.nav-collapsed-img {
	width: 60px;
}
.activeMenuText {
	color: #000 !important;
}
.inactiveMenuText {
	color: #6a75d8 !important;
}
.container-sidebar {
	background-color: $bg-color;
	box-shadow: 1px 0.5rem 1.21rem rgb(117 117 117 / 25%);
	z-index: 99;
	position: fixed;
	height: 100vh;
	transition: 0.3s ease-in;
	overflow-y: auto;
	padding: 10px;
}

/* width */
.container-sidebar::-webkit-scrollbar {
	width: 7px;
	display: none;
}

/* Track */
.container-sidebar::-webkit-scrollbar-track {
	box-shadow: inset 0 0 5px grey;
	border-radius: 10px;
}

/* Handle */
.container-sidebar::-webkit-scrollbar-thumb {
	background: #575d90;
	border-radius: 10px;
}

/* Handle on hover */
.container-sidebar::-webkit-scrollbar-thumb:hover {
	background: #6a75d8;
}
.inactivebar {
	display: none;
}

@media screen and (min-device-width: 300px) and (max-device-width: 1366px) {
	.activebarWidth {
		width: 20%;
	}
	.inactivebarWidth {
		width: 6%;
		padding: 4px;
	}
}
@media screen and (min-device-width: 1367px) and (max-device-width: 3000px) {
	.activebarWidth {
		width: 280px;
	}

	.inactivebarWidth {
		width: 4%;
		padding: 4px;
	}
}
.container_icons {
	margin-left: 10px;
	margin-right: 10px;
}

.menu-principal {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px;
	border-radius: 5px;
	cursor: pointer;
	color: #000;
	margin-bottom: 5px;
	transition: background-color 0.15s ease;
}
.menu-principal:hover {
	background-color: $first-color;
	color: rgb(255, 255, 255);
}
.nav-collapsed-menu {
	justify-content: center;
	border-radius: 5px 5px 5px 5px !important;
	padding: 15px 0px 15px 0px;
}
.menu-principal-icon {
	width: 20px;
	margin-right: 10px;
}

.menu-principal-icon-collapsed {
	width: 20px;
	margin-right: 0;
}

.container-submenu .childactive:hover {
	background-color: #5465ff !important;
	color: rgb(255, 255, 255) !important;
}
.childactive {
	background-color: #5465ff;
	color: rgb(255, 255, 255) !important;
	border-radius: 5px;
}
.submenu:hover {
	color: #000 !important;
}
.menu-title {
	display: flex;
	align-items: center;
	font-size: 14px;
	justify-content: center;
}

.submenu {
	padding: 12px;
	border-radius: 5px;
	cursor: pointer;
	color: #000;
	margin: 5px 0 0 0;
	font-size: 12px;
	transition: background-color 0.15s ease;
	display: none;
}

.submenu-title {
	margin-left: 32px;
}
.submenu:first-child {
	margin-top: 0;
}
.active {
	background-color: $first-color;
	color: #fff;
	border-radius: 0px 0px 5px 5px;
}
.active-menu {
	border-radius: 5px 5px 0px 0px;
	background-color: $first-color;
	color: #fff;
}
.active-one {
	border-radius: 5px 5px 5px 5px;
	background-color: $first-color;
	color: rgb(255, 255, 255);
}

.icon-menu {
	transition: all 0.3s ease-in-out;
}

.visible {
	display: flex;
}
.invisible {
	display: none;
}
.rotate {
	transform: rotate(180deg);
}
</style>

